<template>
  <div
    class="formField checkboxField"
    :class="{
      'checkboxField--Toggle': toggle,
      isDark: dark,
      isError,
      isDisabled
    }"
  >
    <div class="checkboxField__Wrapper">
      <input
        :id="uniqueID"
        :name="name"
        :value="value"
        :disabled="isDisabled"
        :required="isRequired"
        type="checkbox"
        tabindex="-1"
        v-model="fieldValue"
      />
      <label
        class="checkboxField__Box"
        :for="uniqueID"
        :tabindex="!isDisabled && tabindex === undefined ? 0 : -1"
        @keydown="handleKeyDown"
      />
      <div>
        <label :for="uniqueID" class="checkboxField__Label form__Label">
          <slot>{{ label }}</slot>
        </label>
        <FormError :errors="mergedErrors" className="checkboxField__Error" />
      </div>
    </div>
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue'])
  const props = defineProps({
    ...useFormFieldProps(),
    value: {},
    tabindex: {
      type: [Number, String]
    },
    toggle: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  })

  const { mergedErrors, fieldValue, isDisabled, isRequired, isError, uniqueID, triggerValidate } = useFormField(props, emit)

  const handleKeyDown = e => {
    if ([0, 13, 32].includes(e.keyCode) && isDisabled.value === false) {
      e.preventDefault()
      e.target.parentNode.querySelector('[type="checkbox"]').click()
    }
  }

  defineExpose({
    triggerValidate,
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_checkboxField.scss');
</style>
